<template>
  <div class="overview" v-if="flightSchool">
    <div class="overview_header">
      <h1>Overview</h1>
    </div>
    <div class="billingOverviewContainer">
      <b class="billingOverview">Billing Overview</b>
      <div class="saveChangesWrapper">
        <button @click="saveChanges" :disabled="saveDisabled">
          <span>Save Changes</span>
        </button>
      </div>
    </div>
    <div class="billingOverviewWrapper">
      <div class="billingColumn">
        <div class="billingLabel">Billing Period</div>
        <div class="billingValue">{{ flightSchool.billingPeriod }}</div>
      </div>
      <div class="billingColumn">
        <div class="billingLabel">Plan End Date</div>
        <div class="billingValue">
          {{ flightSchool.planEndDate.format("MMM DD, YYYY") }}
        </div>
      </div>
      <div class="billingColumn">
        <div class="billingLabel">Total</div>
        <div class="billingValue">${{ priceTotal }}</div>
      </div>
    </div>
    <div class="billingOverviewContainer">
      <b class="billingOverview">Products</b>
      <div class="addProductWrapper">
        <button @click="openProductSummaryModal('Add')">
          <img src="/static/img/plus.svg" alt="" />
          <span>Add more products</span>
        </button>
      </div>
    </div>
    <div
      class="productsViewWrapper"
      v-for="product of allHiloProducts.filter(
        (data) => schoolCount(data.id) > 0,
      )"
      v-bind:key="product.id"
    >
      <div class="productsHeader">
        <div class="Container">
          <div class="Child">
            <b>{{ product.name }}</b>
            <button class="normal" disabled>
              <span>{{ product.unit }}</span>
            </button>
          </div>
          <button
            :disabled="!saveDisabled"
            @click="openProductSummaryModal('Edit', product)"
          >
            <img class="dottedIcon" alt="" src="/static/img/dotted.svg" />
          </button>
        </div>
      </div>
      <div class="productsGrid">
        <div class="productsColumn">
          <div class="productsLabel">Price</div>
          <div class="productsValue">${{ product.pricePerUnit }}</div>
        </div>
        <div class="productsColumn">
          <div class="productsLabel">{{ product.unit }}</div>
          <div class="productsValue">{{ schoolCount(product.id) }}</div>
        </div>
        <div class="productsColumn">
          <div class="productsLabel">Total</div>
          <div class="productsValue">
            ${{ schoolCount(product.id) * product.pricePerUnit }}
          </div>
        </div>
      </div>
    </div>
    <div class="helpContainer">
      <b class="help">Need Help?</b>
    </div>
    <ProductsModal
      v-if="productSummaryOpen"
      :is-visible="productSummaryOpen"
      :all-hilo-products="allHiloProducts"
      :current-cost="priceTotal"
      :billing-period="flightSchool.billingPeriod"
      :mode="modalMode"
      :edit-product="selectedProduct"
      :original-count="editCount"
      @close="productSummaryOpen = false"
      @update="updateProductsToFlightSchool"
    ></ProductsModal>
    <ToastNotifier ref="toast"></ToastNotifier>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { useLoginStore } from "../../../../../../stores/loginStore";
import ProductsModal from "../ProductsModal.vue";
import ToastNotifier from "../../../../../../components/ToastNotifier.vue";
import HiloProductsAPIService from "../../../../../../servicehandlers/HiloProductsAPIService";
import FlightSchoolsAPIService from "../../../../../../servicehandlers/FlightSchoolsAPIService";

const flightSchoolAPIService = new FlightSchoolsAPIService();
const hiloProductsAPIService = new HiloProductsAPIService();
export default {
  name: "OverView",
  components: {
    ProductsModal,
    ToastNotifier,
  },
  data() {
    return {
      flightSchoolId: useLoginStore().getUser.flightSchoolId,
      allHiloProducts: [],
      flightSchool: null,
      flightSchoolProducts: [],
      productSummaryOpen: false,
      saveDisabled: true,
      modalMode: "",
      selectedProduct: {},
      editCount: 0,
      priceTotal: 0,
    };
  },
  async mounted() {
    await this.getAllHiloProducts();
    await this.getProductsForFlightSchool();
    await this.getFlightSchool();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    handleBeforeUnload(event) {
      if (!this.saveDisabled) {
        // Modern browsers require setting event.returnValue to trigger a prompt.
        event.preventDefault();
        event.returnValue = "";
      }
    },
    calculatePriceTotal() {
      this.priceTotal = 0;
      for (let product of this.flightSchoolProducts.filter(
        (data) => !data.delete,
      )) {
        this.priceTotal += product.hiloProduct.pricePerUnit;
      }
    },
    getAllHiloProducts() {
      return hiloProductsAPIService
        .getAllHiloProducts(this.$router)
        .then((response) => {
          for (let product of response) {
            product.schoolCount = 0;
          }
          this.allHiloProducts = response;
        });
    },
    getFlightSchool() {
      return flightSchoolAPIService
        .getFlightSchoolById(this.flightSchoolId, this.$router)
        .then((response) => {
          response.planEndDate = dayjs(response.planEndDate);
          this.flightSchool = response;
        });
    },
    getProductsForFlightSchool() {
      return hiloProductsAPIService
        .getAllHiloProductsForFlightSchool(this.flightSchoolId, this.$router)
        .then((response) => {
          this.flightSchoolProducts = response;
          this.calculatePriceTotal();
        });
    },
    openProductSummaryModal(mode, product = {}) {
      this.modalMode = mode;
      this.selectedProduct = product;
      if (mode === "Edit") {
        this.editCount = this.schoolCount(product.id);
      }
      this.productSummaryOpen = true;
    },
    saveChanges() {
      return hiloProductsAPIService
        .addProductToFlightSchool(this.flightSchoolProducts, this.$router)
        .then(() => {
          this.getProductsForFlightSchool();
          this.$refs.toast.showSuccess("Successfully saved changes");
          this.saveDisabled = true;
        })
        .catch((e) => {
          this.$refs.toast.showError("Error while saving: " + e);
        });
    },
    async updateProductsToFlightSchool(payload) {
      if (payload.mode === "Edit") {
        if (payload.count > this.schoolCount(payload.productId)) {
          payload.count -= this.schoolCount(payload.productId);
          payload.mode = "Add";
        } else {
          let products = this.flightSchoolProducts.filter(
            (data) => data.productId === payload.productId,
          );
          let diff = this.schoolCount(payload.productId) - payload.count;
          products = products.slice(0, diff);
          for (let product of products) {
            product.delete = true;
          }
        }
      }
      if (payload.mode === "Add") {
        for (let i = 0; i < payload.count; i++) {
          let temp = {
            flightSchoolId: this.flightSchoolId,
            productId: payload.productId,
            hiloProduct: this.allHiloProducts.find(
              (data) => data.id === payload.productId,
            ),
          };
          this.flightSchoolProducts.push(temp);
        }
      }

      this.saveDisabled = false;
      this.calculatePriceTotal();
    },
    schoolCount(id) {
      let total = 0;
      for (let schoolProduct of this.flightSchoolProducts.filter(
        (data) => !data.delete,
      )) {
        if (schoolProduct.productId === id) {
          total++;
        }
      }
      return total;
    },
  },
};
</script>

<style scoped lang="scss">
.normal:disabled {
  opacity: 100%;
}
button:disabled {
  opacity: 50%;
  cursor: not-allowed !important;
}
.overview {
  .overview_header {
    h1 {
      overflow: hidden;
      color: #404040;
      text-overflow: ellipsis;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 35px;
      font-weight: 700;
      margin-bottom: 20px;
    }
  }

  .billingOverviewContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 780px;

    .billingOverview {
      font-size: 18px;
      font-weight: bold;
      color: #404040;
    }

    .saveChangesWrapper {
      border-radius: 10px;
      background-color: #3c78ff;
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 15px;
      color: #fff;

      button {
        background: none;
        border: none;
        color: white;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .addProductWrapper {
      background-color: transparent;
      color: #404040;

      button {
        background: none;
        border: none;
        color: #404040;
        font-size: 13px;
        cursor: pointer;
        font-weight: 300;

        span {
          padding-left: 10px;
        }
      }
    }
  }

  .billingOverviewWrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    max-width: 780px;
    border: 1px solid rgba(64, 64, 64, 0.25);
    border-radius: 15px;
    padding: 20px;
    margin-top: 20px;

    .billingColumn {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      flex: 1;

      .billingLabel {
        font-size: 14px;
        color: #404040;
      }

      .billingValue {
        font-size: 16px;
        color: #606060;
        margin-top: 5px;
      }
    }
  }

  .productsViewWrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 780px;
    border: 1px solid rgba(64, 64, 64, 0.25);
    border-radius: 15px;
    padding: 20px;
    margin-top: 20px;

    .productsHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f5f5f5;
      border-radius: 8px;

      .Container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .Child {
          display: flex;
          align-items: center;
          gap: 10px;

          button {
            border-radius: 5px;
            background-color: #ff6464;
            padding: 6px;
          }
        }
      }

      button {
        background: none;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;

        .dottedIcon {
          width: 20px;
          height: 20px;
        }
      }
    }

    .productsGrid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;

      .productsColumn {
        display: flex;
        flex-direction: column;

        .productsLabel {
          font-size: 14px;
          color: #404040;
        }

        .productsValue {
          font-size: 16px;
          color: #606060;
          margin-top: 5px;
        }
      }
    }
  }
  .helpContainer {
    margin-top: 20px;
  }
}
</style>
